<template>
    <template v-if="products?.length">
        <ticket-status-card-item v-for="(product, index) in productsOrdered" :key="index" v-bind="product" />
    </template>
    <template v-if="pendingProducts?.length">
        <ticket-status-card-pending-item
            v-for="(product, index) in pendingProducts"
            :key="index"
            v-bind="product"
            :show-multiple-pending-ticket-indicator="showMultiplePendingTicketIndicator"
        />
    </template>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import TicketStatusCardItem from './components/TicketStatusCardItem.vue';
import TicketStatusCardPendingItem from './components/TicketStatusCardPendingItem.vue';
import { ITicketCardProductList } from '../../types';
import { useCardStore } from '@/features/TravelCards/store/cardStore';
import { storeToRefs } from 'pinia';

const cardStore = useCardStore();
const { isRecentPendingOrders } = storeToRefs(cardStore);

const props = withDefaults(defineProps<ITicketCardProductList>(), { products: () => [], pendingProducts: () => [] });

const productsOrdered = computed(() => Array.from(props.products).sort((a, b) => (a.validityTime ?? 0) - (b.validityTime ?? 0)));
const showMultiplePendingTicketIndicator = computed(() => isRecentPendingOrders && props.products?.length > 1);
</script>
